<!-- TODO: should be investigated why this is happening: Full height is not
  working if we pass position like: position="l" -->
<!-- TODO: closing overlay on backdrop click is not implemented, because it is
   not working properly if there are two overlays displayed, should be
   investigated
   -->
<atn-ds-slideout-overlay
  name="Processes"
  [position]="'l'"
  [offsetX]="store.widthSg()"
>
  <!-- TODO: Should be refactored div.process-slideout-icons should be removed
 once subscriptions are fixed in api service of the entity ec -->
  <div
    class="process-slideout-icons"
    actions
  >
    <div
      class="process-slideout-icons__poll"
      atnDsTooltip="Auto-refreshes process list"
    >
      <atn-ds-toggle-button
        [active]="processesPollingPlugin.feature.selectors.isStarted.asSignal()"
        (activeChange)="
          processesPollingPlugin.feature.actions.togglePolling
            .from('Slideout.Header.Poll.Toggle.Button.Clicked')
            .dispatch()
        "
      />
    </div>
    <i
      class="atn-icon atn-repeat atn-blue"
      (click)="refreshProcessesHandler()"
      atnDsTooltip="Refreshes process list"
      data-test-id="refresh-process-list"
    ></i>
    <i
      class="atn-icon atn-close atn-red"
      (click)="closeIconClickHandler()"
    ></i>
  </div>

  <atn-process-list />
</atn-ds-slideout-overlay>
